function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 *
 * @param {string} decorator
 * @param {any|function} value = null
 * @returns {function(*=): void}
 */
export default function decopt(decorator) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var defaultSetter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var option = decorator;

  if (decorator.split(':', 2).length === 2) {
    option = decorator.split(':', 2)[1];
    decorator = decorator.split(':', 2)[0];
  }

  var decopt = {
    decorator: decorator,
    option: option,
    setter: typeof value === "function" ? value : function (t, f, v) {
      t.options[Array.isArray(option) ? option[0] : option] = typeof v === "undefined" ? value : v;
    },
    value: typeof value === "function" ? [] : [value]
  };
  if (defaultSetter === null) decopt.defSetter = decopt.setter;else if (typeof defaultSetter === "function") decopt.defSetter = defaultSetter;else decopt.defSetter = function () {};
  return function (target) {
    // create blank or copy parents decopts
    if (!target.hasOwnProperty('__decopts')) Object.defineProperty(target, '__decopts', {
      value: _typeof(target.__decopts) === "object" ? _objectSpread({}, target.__decopts) : {}
    }); // create blank options and fill with parent's decopts

    if (!target.hasOwnProperty('options')) {
      Object.defineProperty(target, 'options', {
        value: {}
      });

      for (var _i = 0, _Object$values = Object.values(target.__decopts); _i < _Object$values.length; _i++) {
        var _decopt = _Object$values[_i];

        _decopt.defSetter.apply(_decopt, [target, false].concat(_toConsumableArray(_decopt.value)));
      }
    } // add decopt to target


    target.__decopts[decopt.decorator] = decopt; // run default decopt

    decopt.defSetter.apply(decopt, [target].concat(_toConsumableArray(decopt.value))); // add decorator to target

    target[decopt.decorator] = function () {
      var _arguments = arguments;
      return function (target, fn) {
        // if function decorator set target
        target = typeof fn === "undefined" ? target : target.constructor; // create own options (and fill with defaults) if not exists

        if (!target.hasOwnProperty('options')) {
          Object.defineProperty(target, 'options', {
            value: {}
          });

          for (var _i2 = 0, _Object$values2 = Object.values(target.__decopts); _i2 < _Object$values2.length; _i2++) {
            var _decopt2 = _Object$values2[_i2];

            _decopt2.defSetter.apply(_decopt2, [target, false].concat(_toConsumableArray(_decopt2.value)));
          }
        } // run decorator setter


        decopt.setter.apply(decopt, [target, fn].concat(_toConsumableArray(_arguments)));
      };
    };
  };
}